import React from 'react';
import ChatMessage from './ChatMessage';
import { ConversationMessage } from '../goFormz-agent-types';

interface ChatMessagesProps {
  sessionId: string;
  messages: ConversationMessage[];
  formulaSelected?: (formula: string) => void;
}

export default function ChatMessages({ sessionId, messages, formulaSelected }: ChatMessagesProps) {
  return (
    <>
      {messages.map((message, index) => (
        <ChatMessage sessionId={sessionId} key={index} message={message} formulaSelected={formulaSelected} />
      ))}
    </>
  );
}
